import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";

function FibQuestionsRenderer({
  handleFibQuestionChange,
  handleFibAnswerChange,
  handleFibQuestionsEdit,
  handleFibAnswersEdit,
  handleFibQuestionDelete,
  index,
  question,
}) {

  const normalizedQuestion = normalizeQuestion(question, "fib");

  return (
    <>
      {/* {fibQuestions.map((fibQuestion, index) => ( */}
      <div className="mb-4  border-slate-100 border-2 hover:border-dotted  hover:border-[#f4833d]  rounded question-answer-container p-4">
        <div className="flex place-content-between">
          <p className="flex">
            <span>{index + 1}. </span>{" "}
            {question.editing ? (
              <div
                contentEditable="true"
                id={`question-${normalizedQuestion.index}`}
                className={` `}
                onBlur={(e) => {
                  handleFibQuestionChange(normalizedQuestion.index, e.target.textContent);
                  handleFibQuestionsEdit(normalizedQuestion.index);
                }}
                dangerouslySetInnerHTML={{ __html: normalizedQuestion.question }}
              />
            ) : (
              <span
                onClick={() => handleFibQuestionsEdit(normalizedQuestion.index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{ __html: normalizedQuestion.question }}
              />
            )}
          </p>
          <div className="flex edit-delete-icons">
            <Tooltip
              title="Edit"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleFibQuestionsEdit(normalizedQuestion.index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>{" "}
              </button>
            </Tooltip>

            <Tooltip
              title="Delete"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleFibQuestionDelete(normalizedQuestion.index)}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>{" "}
              </button>
            </Tooltip>
          </div>
        </div>

        <p className="flex">
          <p className="font-semibold me-2">Answer:</p>{" "}
          {question.editingAnswer ? (
            <div
              contentEditable
              className="editable-answer"
              onBlur={(e) => {
                handleFibAnswerChange(normalizedQuestion?.index, e.target.textContent);
                handleFibAnswersEdit(normalizedQuestion?.index);
              }}
              dangerouslySetInnerHTML={{ __html: normalizedQuestion?.answer }}
            />
          ) : (
            <span
              onClick={() => handleFibAnswersEdit(normalizedQuestion?.index)}
              className="cursor-pointer"
              dangerouslySetInnerHTML={{ __html: normalizedQuestion?.answer }}
            />
          )}
        </p>
      </div>
    </>
  );
}

export default FibQuestionsRenderer;
